import { useState, useContext } from "react";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../services/firebase";
import "./Auth.css";
import { AppContext } from "../context/AppContext";

export default function Register({ switchMode }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { setIsOpenLogin } = useContext(AppContext);

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      // 1. Create user
      await createUserWithEmailAndPassword(auth, email, password);

      // 2. Auto-login after creation
      await signInWithEmailAndPassword(auth, email, password);
      setIsOpenLogin(false); // Closes the overlay on successful login

      // The AuthContext will detect the state change automatically.
    } catch (err) {
      console.error(err);
      setError("Registration failed. Please check your email and password (min. 6 characters).");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Sign Up</h2>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleRegister}>
          <input
            className="auth-input"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            className="auth-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button className="auth-button" type="submit">
            Create Account
          </button>
        </form>

        <div className="auth-switch" onClick={switchMode}>
          Already have an account? Sign in
        </div>
      </div>
    </div>
  );
}